import { populate } from "populate";

const raw = {
  width: 1360,
  height: 750,
  x: 0,
  y: 0,
  list: [
    {
      id: "d61f7a2e-cad4-4612-af24-663d994818cc",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "86e61955-5900-4f5c-881e-d38f0762ff4a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 174,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "Pet_Minigame_arrow",
      parent: "d61f7a2e-cad4-4612-af24-663d994818cc",
      data: ""
    },
    {
      id: "35eed628-63c9-4008-8102-43e187f412d5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "Pet_Minigame_infoBubble",
      parent: "d61f7a2e-cad4-4612-af24-663d994818cc",
      data: ""
    },
    {
      id: "b7102a0a-286a-4351-b86e-5ccd4440acf4",
      type: "Text",
      name: "ftuxText",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "FarmPetFTUX1",
      localize: true,
      maxWidth: 275,
      maxHeight: 100,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#4175b5",
        stroke: "black",
        strokeThickness: 0,
        align: "center",
        wordWrap: true,
        wordWrapWidth: 275,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "35eed628-63c9-4008-8102-43e187f412d5",
      data: ""
    },
    {
      id: "6082a487-1a98-4bcc-aabe-14c67b079351",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -152,
      y: -57,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "Pet_Minigame_info",
      parent: "35eed628-63c9-4008-8102-43e187f412d5",
      data: ""
    }
  ]
} as const;

export class PetFTUXLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  ftuxText: GameObject<PIXI.Text>;

  constructor() {
    populate(this, raw);
  }
}
